import {
  getData,
  postData
} from '@/assets/js/api.js'


//查询HCL列表
export const FindHCLList = (params, fn) => {
  let methods = '/api/HCL/FindHCLList';
  getData(methods, params, 1, fn);
};

//删除HCL
export const DeleteHCL = (params, fn) => {
  let methods = '/api/HCL/DeleteHCL';
  getData(methods, params, 1, fn);
};

//创建HCL
export const CreateHCL = (params, fn) => {
  let methods = '/api/HCL/CreateHCL';
  postData(methods, params, 1, fn);
};

//编辑HCL
export const EditHCL = (params, fn) => {
  let methods = '/api/HCL/EditHCL';
  postData(methods, params, 1, fn);
};

//查询单个HCL
export const FindHCL = (params, fn) => {
  let methods = '/api/HCL/FindHCL';
  getData(methods, params, 1, fn);
};

//开启HCL
export const OpenHCL = (params, fn) => {
  let methods = '/api/HCL/Open';
  getData(methods, params, 1, fn);
};

//关闭HCL
export const CloseHCL = (params, fn) => {
  let methods = '/api/HCL/Close';
  getData(methods, params, 1, fn);
};

//查询HCL标准模板
export const FindSysHCLTemplateList = (params, fn) => {
  let methods = '/api/HCL/FindSysHCLTemplateList';
  getData(methods, params, 1, fn);
};

//查询HCL自定义用户模板
export const FindUserHCLTemplateList = (params, fn) => {
  let methods = '/api/HCL/FindUserHCLTemplateList';
  getData(methods, params, 1, fn);
};

//删除自定义hcl模板
export const DeleteHCLTemplate = (params, fn) => {
  let methods = '/api/HCL/DeleteHCLTemplate';
  postData(methods, params, 1, fn);
};

//创建自定义hcl模板
export const CreateHCLTemplate = (params, fn) => {
  let methods = '/api/HCL/CreateHCLTemplate';
  postData(methods, params, 1, fn);
};

//修改自定义hcl模板
export const UpdateHCLTemplate = (params, fn) => {
  let methods = '/api/HCL/UpdateHCLTemplate';
  postData(methods, params, 1, fn);
};

//设备列表
export const ChooseHCLDeviceList = (params, fn) => {
  let methods = '/api/HCL/ChooseHCLDeviceList';
  return getData(methods, params, 1, fn);
};

